import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie-player';

/**
 * LottiePlayer
 */

class LottiePlayer extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.play = () => this.setState({ isPlaying: true });
    this.pause = () => this.setState({ isPlaying: false });
    this.paused = () => !this.state.isPlaying;
    this.togglePlayPause = () => this.setState({ isPlaying: !this.state.isPlaying });

    /** State */
    this.state = { isPlaying: this.props.play };
    //
  }

  render() {
    const elementClass = this.props.className || '';
    return <Lottie animationData={this.props.animationData} play={this.state.isPlaying} loop={this.props.loop} className={elementClass} />;
  }
}

LottiePlayer.propTypes = {
  animationData: PropTypes.object.isRequired,
  play: PropTypes.bool,
  loop: PropTypes.bool,
  className: PropTypes.string,
};

LottiePlayer.defaultProps = {
  play: false,
  loop: false,
};

export default LottiePlayer;
